import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  validatePersonalTimeRecordsUpToDate(
    request: Boundaries["validatePersonalTimeRecordsUpToDate"]["request"],
  ): void;
}

function useValidatePersonalTimeRecordsUpToDate(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isValidatePersonalTimeRecordsUpToDateRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isValidatePersonalTimeRecordsUpToDateRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isValidatePersonalTimeRecordsUpToDateRequestFailure(resource),
    ),
    validatePersonalTimeRecordsUpToDate:
      core.validatePersonalTimeRecordsUpToDate,
  };
}

export { useValidatePersonalTimeRecordsUpToDate };
